module.exports = __webpack_public_path__ + "img/confirmation.924e4b1b.png";